import { createContext, useState } from 'react';

export const FormContext = createContext();

export const FormProvider = ({ children }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    apellidos: '',
    email: '',
    dni: '',
    ruc:'',
    telefono: '',
    departamento:'',
    provincia:'',
    distrito:'',
    tipoDocumento: '',
    tipoEntrega:'',
    tipoDireccion: '',
    direccion: '',
    direccionReferencia: ''
  });

  const updateField = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <FormContext.Provider value={{ formData, setFormData, updateField }}>
      {children}
    </FormContext.Provider>
  );
};
